import { createAction, props } from '@ngrx/store';
import { Invoice, PagedInvoices, InvoiceFilters } from '../../models/invoices.model';

export const loadInvoices = createAction(
  '[Invoices] Load Invoices',
  props<{ filters: InvoiceFilters }>()
);

export const loadInvoicesSuccess = createAction(
  '[Invoices] Load Invoices Success',
  props<{ invoices: PagedInvoices }>()
);

export const loadInvoicesFailure = createAction(
  '[Invoices] Load Invoices Failure',
  props<{ error: any }>()
);

export const createInvoices = createAction(
  '[Invoices] Create Invoices',
);

export const createInvoicesSuccess = createAction(
  '[Invoices] Create Invoices Success',
  props<{ invoices: PagedInvoices}>()
);

export const createInvoicesFailure = createAction(
  '[Invoices] Create Invoices Failure',
  props<{ error: any }>()
);

export const loadInvoiceById = createAction(
  '[Invoices] Load Invoice By Id',
  props<{ id: number }>()
);

export const loadInvoiceByIdSuccess = createAction(
  '[Invoices] Load Invoice By Id Success',
  props<{ invoice: Invoice }>()
);

export const loadInvoiceByIdFailure = createAction(
  '[Invoices] Load Invoice By Id Failure',
  props<{ error: any }>()
);

export const updateServicePrice = createAction(
  '[Invoices] Update Service Price',
  props<{ invoiceId: number; serviceId: number; newPrice: number }>()
);

export const updateServicePriceSuccess = createAction(
  '[Invoices] Update Service Price Success',
  props<{ invoice: Invoice }>()
);

export const updateServicePriceFailure = createAction(
  '[Invoices] Update Service Price Failure',
  props<{ error: any }>()
);

export const updateInvoiceReference = createAction(
  '[Invoices] Update Invoice Reference',
  props<{ invoiceId: number; payment_reference_number: string }>()
);

export const updateInvoiceReferenceSuccess = createAction(
  '[Invoices] Update Invoice Reference Success',
  props<{ invoice: Invoice }>()
);

export const updateInvoiceReferenceFailure = createAction(
  '[Invoices] Update Invoice Reference Failure',
  props<{ error: any }>()
);

export const regenerateInvoice = createAction(
  '[Invoices] Regenerate Invoice',
  props<{ invoiceId: number }>()
);

export const regenerateInvoiceSuccess = createAction(
  '[Invoices] Regenerate Invoice Success',
  props<{ invoice: Invoice }>()
);

export const regenerateInvoiceFailure = createAction(
  '[Invoices] Regenerate Invoice Failure',
  props<{ error: any }>()
);

export const recalculateInvoices = createAction(
  '[Invoices] Recalculate Invoices',
  props<{ from_date: string; to_date: string }>()
);

export const recalculateInvoicesSuccess = createAction(
  '[Invoices] Recalculate Invoices Success',
  props<{ result: any }>()
);

export const recalculateInvoicesFailure = createAction(
  '[Invoices] Recalculate Invoices Failure',
  props<{ error: any }>()
);

export const recalculateInvoice = createAction(
  '[Invoices] Recalculate Invoice',
  props<{ invoice_id: number }>()
);

export const recalculateInvoiceSuccess = createAction(
  '[Invoices] Recalculate Invoice Success',
  props<{ result: any }>()
);

export const recalculateInvoiceFailure = createAction(
  '[Invoices] Recalculate Invoice Failure',
  props<{ error: any }>()
);
